import { configureStore } from '@reduxjs/toolkit'
import { createStore, applyMiddleware } from 'redux';
import { composeWithDevTools } from "redux-devtools-extension";
import thunk from 'redux-thunk';
import { browserHistory } from 'react-router';
import reducers from './reducers';

const middleware = [thunk];
const initialState = {};


const saveToLocalStorage = (state) => {
  try {
    localStorage.setItem('state', JSON.stringify(state));
  } catch (e) {
    console.error(e);
  }
};

const loadFromLocalStorage = () => {
  try {
    const stateStr = localStorage.getItem('state');
    return stateStr ? JSON.parse(stateStr) : undefined;
  } catch (e) {
    console.error(e);
    return undefined;
  }
};

const persistedStore = undefined;

const store = createStore(
  reducers,
  persistedStore,
  composeWithDevTools(applyMiddleware(...middleware))
);
  
// store.subscribe(() => {
//   saveToLocalStorage(store.getState());
// });
export default store;